<template>
  <section class="hero">
    <div class="hero-content">
      <h1 class="title animate-fade-in">AITRA</h1>
      <p class="subtitle animate-fade-in-delay">Beyond Language, Across Minds</p>
      <p class="description animate-fade-in-delay-2">
        AITRA(AI for Ajou International Translator)는 실시간 AI 통·번역으로 언어의 경계를 없애는 글로벌 커뮤니케이션 시스템입니다.<br>
        통·번역 정확도에서 Zoom을 능가하고, RAG 기반 AI 기술로 Google Translator를 뛰어넘는 맥락 이해력을 제공합니다.<br>
        회의·강의 중 발언을 자동 번역·요약·기록하며, 다국어 동시 통역과 자동 회의록 생성으로 협업 효율을 높입니다.<br>
        AITRA는 비즈니스 회의부터 국제 강의까지 지원하는 AI 글로벌 커뮤니케이션 솔루션입니다.
      </p>
      <br><br>
      <router-link to="/login" class="btn btn-primary">바로 시작하기</router-link>
    </div>
  </section>
</template>

<script setup>
</script>

<style scoped>
.hero {
  position: relative;
  min-height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  color: #FFFFFF;
  margin-left: calc(-50vw + 50%);
  margin-right: calc(-50vw + 50%);
  box-sizing: border-box;
  overflow: hidden;
  background-image: url('@/assets/meeting.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1; /* 기본 z-index로 복원 */
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.75); /* 투명도를 0.7로 증가 (더 어둡게) */
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 2; /* 오버레이 위에 콘텐츠가 보이도록 z-index 설정 */
  width: min(1200px, 100% - 2rem);
  margin: 0 auto;
  text-align: center;
  padding: 2rem;
}

.title {
  font-size: clamp(3rem, 8vw, 5rem);
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: #FFFFFF;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3); /* 텍스트 가독성을 위한 그림자 */
}

.subtitle {
  font-size: clamp(1.2rem, 3vw, 1.5rem);
  margin-bottom: 1.5rem;
  color: #FFFFFF;
  line-height: 1.6;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}

.description {
  font-size: 0.9rem;
  line-height: 1.8;
  color: #FFFFFF;
  max-width: 900px;
  margin: 0 auto;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  opacity: 0.9;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in {
  animation: fadeInUp 1s ease forwards;
}

.animate-fade-in-delay {
  animation: fadeInUp 1s ease forwards;
  animation-delay: 0.3s;
  opacity: 0;
}

.animate-fade-in-delay-2 {
  animation: fadeInUp 1s ease forwards;
  animation-delay: 0.6s;
  opacity: 0;
  font-size: 0.9rem;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
}

.pulse-animation:hover {
  animation: pulse 2s infinite;
}

@media (max-width: 640px) {
  .hero {
    padding: 1rem;
  }
  
  .button-group {
    flex-direction: column;
    gap: 1rem;
  }
  
  .btn {
    width: 100%;
    justify-content: center;
  }
}
</style> 